import {
  createColumnHelper,
  type DisplayColumnDef,
  type RowData,
} from '@tanstack/react-table';

import { DATA_TABLE_SPACER_COLUMN_ID } from '../../constants.js';
import type { TDataTableFeatures } from '../types/features.types.js';

const layoutColumnHelper = createColumnHelper<TDataTableFeatures, RowData>();

export const SPACER_COLUMN: DisplayColumnDef<TDataTableFeatures, RowData> =
  layoutColumnHelper.display({
    id: DATA_TABLE_SPACER_COLUMN_ID,
    header: () => undefined,
    cell: () => undefined,
    enableSorting: false,
    enablePinning: false,
    enableUserActions: false,
    enableResizing: false,
    enableHiding: false,
    meta: {
      builtin: true,
      builtinPlacement: 'suffix',
      hasCustomCellRenderer: true,
      hasCustomHeaderRenderer: true,
      spacer: true,
      cellDeps: () => {
        // empty dependency to avoid unnecessary re-renders
        return [];
      },
    },
  });
